import { ScrollView, View } from "@-/com.npmjs.react-native";
import type { SharedValue } from "@-/com.npmjs.react-native-reanimated";
import type { ReactNode } from "react";
import type { ChinaMapSheetDetent } from "#china-map-sheet-heights";

/** The web counterpart is an ordinary scrolling panel, without sheet gestures or detents. */
export function ChinaMapBottomSheet({
  children,
  corner,
  restingKey,
  welcome = null,
}: {
  animatedPosition: SharedValue<number>;
  children: ReactNode;
  corner?: ReactNode;
  detent: ChinaMapSheetDetent;
  restingKey: string;
  topInset: number;
  welcome?: ReactNode;
}) {
  return (
    <View className="min-h-0 flex-1 bg-background" testID="china-map-details-panel">
      <View className="z-10 h-11 border-b border-border px-4 py-3" testID="china-map-panel-wallet">
        {corner}
      </View>
      <ScrollView
        className="min-h-0 flex-1"
        contentContainerClassName="pb-6"
        key={restingKey}
        testID="china-map-panel-scroll"
      >
        {welcome}
        {children}
      </ScrollView>
    </View>
  );
}
